module.exports = __webpack_public_path__ + "static/img/reason_head_1.fd18b0f8.png";